import { Routes } from "@angular/router";
import { Login } from "./pages/login/login";
import { Register } from "./pages/register/register";
import { ConfirmEmail } from "./pages/confirm-email/confirm-email";

export const accountRoutes: Routes = [
  {
    path: "login",
    component: Login
  },
  {
    path: "register",
    component: Register
  },
  {
    path: "confirm-email/:userId/:emailToken",
    component: ConfirmEmail
  },
  {
    path: "",
    redirectTo: "login",
    pathMatch: "full"
  }
];
